/**
 * A helper function to ensure grade consistency
 * @name grades
 * @param {string} grade
 * @returns {string}
 */
export const grades = (grade: string): string => {
    switch (grade.toString().toUpperCase()) {
        case "PRE":
        case "C3":
        case "C4":
        case "C5":
        case "CF":
        case "CF4":
        case "CF5":
        case "CH5":
        case "CP3":
        case "CP4":
        case "CP5":
        case "CT5":
        case "I1":
        case "I2":
        case "I3":
        case "P3":
        case "P4":
        case "P5":
        case "PK":
        case "UH5":
        case "UP4":
        case "UP5":
        case "UT5":
            return "PRE";
        case "K":
        case "K_HALF":
        case "K_HALF_AM":
        case "K_HALF_PM":
        case "K_FULL":
        case "KINDERGARTEN":
        case "0F":
        case "0H":
        case "00":
            return "K";
        case "FIRST":
        case "01":
            return "01";
        case "SECOND":
        case "02":
            return "02";
        case "THIRD":
        case "03":
            return "03";
        case "FOURTH":
        case "04":
            return "04";
        case "FIFTH":
        case "05":
            return "05";
        case "SIXTH":
        case "06":
            return "06";
        case "SEVENTH":
        case "07":
            return "07";
        case "EIGHTH":
        case "08":
            return "08";
        case "NINTH":
        case "09":
            return "09";
        case "TENTH":
        case "10":
            return "10";
        case "ELEVENTH":
        case "11":
            return "11";
        case "TWELFTH":
        case "12":
            return "12";
        case "THIRTEENTH":
        case "13":
            return "13";
        default:
            return "-";
    }
};

/**
 * A helper function to ensure grade consistency
 * @name gradesOrdinal
 * @param {string} grade
 * @returns {number}
 */
export const gradesOrdinal = (grade: string): number => {
    switch (grade.toString().toUpperCase()) {
        case "PRE":
        case "C3":
        case "C4":
        case "C5":
        case "CF":
        case "CF4":
        case "CF5":
        case "CH5":
        case "CP3":
        case "CP4":
        case "CP5":
        case "CT5":
        case "I1":
        case "I2":
        case "I3":
        case "P3":
        case "P4":
        case "P5":
        case "PK":
        case "UH5":
        case "UP4":
        case "UP5":
        case "UT5":
            return -1;
        case "K":
        case "K_HALF":
        case "K_HALF_AM":
        case "K_HALF_PM":
        case "K_FULL":
        case "KINDERGARTEN":
        case "0F":
        case "0H":
        case "00":
            return 0;
        case "FIRST":
        case "01":
            return 1;
        case "SECOND":
        case "02":
            return 2;
        case "THIRD":
        case "03":
            return 3;
        case "FOURTH":
        case "04":
            return 4;
        case "FIFTH":
        case "05":
            return 5;
        case "SIXTH":
        case "06":
            return 6;
        case "SEVENTH":
        case "07":
            return 7;
        case "EIGHTH":
        case "08":
            return 8;
        case "NINTH":
        case "09":
            return 9;
        case "TENTH":
        case "10":
            return 10;
        case "ELEVENTH":
        case "11":
            return 11;
        case "TWELFTH":
        case "12":
            return 12;
        case "THIRTEENTH":
        case "13":
            return 13;
        default:
            return 12;
    }
};
